import { render, staticRenderFns } from "./reserveCheck.vue?vue&type=template&id=123a5dee&scoped=true&"
import script from "./reserveCheck.vue?vue&type=script&lang=js&"
export * from "./reserveCheck.vue?vue&type=script&lang=js&"
import style0 from "./reserveCheck.vue?vue&type=style&index=0&id=123a5dee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123a5dee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer,VFlex,VImg,VLayout})
